import * as React from 'react';

import {
    Props,
} from 'one-ui';

import {
    BoxLight,
    BoxLightBody,
    BoxLightHeader,
} from 'one-ui-box';

export interface TableLightProps extends Props {
    title?: string;
    headerButtons?: JSX.Element;
    body: JSX.Element;
    screnpopepicbutton?:JSX.Element;
}

export const TableLight = ({
    body,
    title,
    headerButtons,
    screnpopepicbutton
}: TableLightProps): JSX.Element => {

    return (
        <BoxLight>
            <BoxLightHeader title={title} screnpopepicbutton={screnpopepicbutton}>
                {headerButtons}
            </BoxLightHeader>
            <BoxLightBody>
                {body}
            </BoxLightBody>
        </BoxLight>
    );
};
